<template>
  <div class="identify_page">
    <el-menu
      :default-active="onRoutes"
      class="el-menu-demo"
      router
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/imgIdentify">图片列表</el-menu-item>
      <el-menu-item index="/videoIdentify">视频列表</el-menu-item>
      <el-menu-item index="/docList">文档列表</el-menu-item>
      <el-menu-item index="/realTime">实时识别</el-menu-item>
      <el-menu-item index="/Hbase">Hbase查询</el-menu-item>
    </el-menu>
    <div class="identify_content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      onRoutes: "/imgIdentify"
    };
  },
  created() {
    this.onRoutes = this.$route.path;
  }
};
</script>

<style lang="less" scoped>
.identify_page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .identify_content {
    height: 0;
    flex: 1;
    background: #f3f3f3;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/index.vue